module.exports = __webpack_public_path__ + "static/media/chatLike.45b1021d.svg";